module.exports = __webpack_public_path__ + "img/160043.83c06591.png";